
import * as firebaseAPI from './firebaseAPI';
import * as mockAPI from './mockAPI';
import * as feedbackService from './feedbackService';
import * as regAPI from './registrationService';
import * as revenueAPI from './revenueService';
import * as logAPI from './logService';
import * as emailAPI from './emailService';
import { isProduction } from '../utils/env';

const IS_PROD = isProduction();

// On Production: Merge all real Firebase services
// On DEV: Use ONLY the mockAPI which contains implementations for all modules
const api = IS_PROD 
    ? { 
        ...firebaseAPI, 
        ...feedbackService, 
        ...regAPI, 
        ...revenueAPI, 
        ...logAPI,
        ...emailAPI
      } 
    : { 
        ...mockAPI 
      };

if (IS_PROD) {
    console.log("Running in PRODUCTION mode - Mock data disabled.");
}

// Export namespaces that correctly switch between real and mock implementations
export const feedbackAPI = {
    submitFeedback: (api as any).submitFeedback,
    replyFeedback: (api as any).replyFeedback,
    fetchActiveFeedback: (api as any).fetchActiveFeedback,
    fetchResolvedFeedback: (api as any).fetchResolvedFeedback,
    deleteFeedbackMedia: (api as any).deleteFeedbackMedia
};

export const newsAPI = {
    fetchNews: (api as any).fetchNews,
    saveNewsItem: (api as any).saveNewsItem,
    deleteNewsItem: (api as any).deleteNewsItem
};

export const {
    loadAllData,
    updateFeeSettings,
    saveChargesBatch,
    updateChargeStatuses,
    updateChargePayments,
    confirmSinglePayment,
    updatePaymentStatusBatch,
    updateResidentData,
    wipeAllBusinessData,
    saveUsers,
    deleteUsers,
    saveTariffs,
    saveAdjustments,
    saveWaterReadings,
    saveVehicles,
    importResidentsBatch,
    getLockStatus,
    setLockStatus,
    getBillingLockStatus,
    setBillingLockStatus,
    subscribeToCollection,
    resetUserPassword,
    logActivity,
    fetchLatestLogs,
    createProfileRequest,
    submitUserProfileUpdate,
    linkUserUid,
    getPendingProfileRequest, 
    getAllPendingProfileRequests, 
    resolveProfileRequest, 
    updateResidentAvatar,
    fetchWaterLocks,
    addMiscRevenue,
    getMiscRevenues,
    getMonthlyMiscRevenues,
    deleteMiscRevenue,
    updateUserProfile,
    fetchNews,
    saveNewsItem,
    deleteNewsItem,
    injectLogAndNotif,
    getSystemMetadata,
    updateUnitGrouping,
    ungroupUnits,
    fetchCollection,
    fetchCollectionWithOnSnapshot,
    fetchRecentAdjustments,
    fetchRecentWaterReadings,
    fetchResidentSpecificData,
    fetchChargesForResident,
    fetchUserForLogin,
    submitFeedback,
    replyFeedback,
    fetchActiveFeedback,
    fetchResolvedFeedback,
    submitServiceRegistration,
    fetchRegistrations,
    processRegistrationAction,
    deleteFeedbackMedia,
    deleteRegistrationMedia,
    fetchActiveCharges,
    getDashboardCounts,
    fetchInvoiceSettings,
    fetchTariffsData,
    fetchOtherFeeConfigs,
    saveOtherFeeConfig,
    deleteOtherFeeConfig,
    incrementVisitCount,
    fetchVisitStats,
    createAdminNotification,
    resetUserPasswordToDefault,
    sendEmailAPI,
    sendResetPasswordEmail
} = api as any;
